var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import identity from 'lodash/identity';
import * as Parser from '../../Payment/PaymentAccountParser';
import astroPayBankTransaltions from './astroPayBankTransaltions';
import getByPath from 'lodash/get';
import axios from 'axios';
import translate from '../../../../lib/utils/translate';
import Input from '../../../../components/Input';
import Select from '../../../../components/Select';
import Loader from '../../../../components/Loader';

import Payment from 'payment';

var injectMethod = function injectMethod(newProps, BaseComponent) {
  return function (props) {
    return React.createElement(BaseComponent, _extends({}, props, newProps));
  };
};

var formatCreditCardNumber = function formatCreditCardNumber(value) {
  value = value.replace(/[^\d|\*]/g, '');
  var issuer = Payment.fns.cardType(value);
  switch (issuer) {
    case 'amex':
      value = value.slice(0, 4) + ' ' + value.slice(4, 10) + ' ' + value.slice(10, 15);
      break;
    case 'dinersclub':
      value = value.slice(0, 4) + ' ' + value.slice(4, 8) + ' ' + value.slice(8, 12) + ' ' + value.slice(12, 14);
      break;
    default:
      value = value.slice(0, 4) + ' ' + value.slice(4, 8) + ' ' + value.slice(8, 12) + ' ' + value.slice(12, 16);
      break;
  }
  return value.trim();
};

var Creditcard = function Creditcard(_ref) {
  var account = _ref.account,
      intl = _ref.intl,
      method = _ref.method,
      provider = _ref.provider,
      change = _ref.change,
      values = _ref.values;

  return React.createElement(
    'div',
    null,
    React.createElement(Input, {
      disabled: account.accountId,
      transform: function transform(creditCardNumber) {
        return formatCreditCardNumber(creditCardNumber);
      },
      value: values['cardNumber'],
      onChange: function onChange(e, creditCardNumber) {
        return change && change('cardNumber', creditCardNumber);
      },
      name: 'cardNumber',
      label: translate({ id: 'cashier.details.cardNumber' }, intl),
      required: !account.accountId,
      inputmode: 'numeric',
      autocomplete: 'cc-number',
      autoFocus: !account.accountId
    }),
    React.createElement(Input, {
      disabled: account.accountId,
      value: values['cardHolder'],
      onChange: function onChange(e, cardHolder) {
        return change && change('cardHolder', cardHolder);
      },
      pattern: '[^0-9]*',
      name: 'cardHolder',
      type: 'cardHolder',
      autocomplete: 'cc-name',
      label: translate({ id: 'cashier.details.cardHolder' }, intl),
      required: !account.accountId
    }),
    React.createElement(
      'div',
      { className: 'layout-item' },
      React.createElement(Input, {
        name: 'expiryDate',
        pattern: '(?:0[1-9]|1[0-2])/[0-9]{2}',
        value: values['expiryDate'],
        onChange: function onChange(e, expiryDate) {
          return change && change('expiryDate', expiryDate);
        },
        transform: function transform(expirationDate) {
          expirationDate = expirationDate.replace(/\D+/g, '');
          return expirationDate.length >= 3 ? expirationDate.slice(0, 2) + '/' + expirationDate.slice(2, 4) : expirationDate;
        },
        disabled: account.accountId,
        label: translate({ id: 'cashier.details.validThruDate' }, intl),
        required: !account.accountId,
        type: 'expiration',
        autocomplete: 'cc-exp',
        placeholder: 'MM/YY'
      }),
      method === 'deposit' && React.createElement(Input, {
        name: 'cvv',
        pattern: '\\d{3,4}',
        value: values['cvv'],
        onChange: function onChange(e, cvv) {
          return change && change('cvv', cvv);
        },
        transform: function transform(cvv) {
          return cvv.slice(0, 4);
        },
        label: translate({ id: 'cashier.details.cvv' }, intl),
        required: true,
        type: 'cvv',
        autocomplete: 'cc-csc',
        autoFocus: account.accountId,
        provider: provider
      })
    )
  );
};

var Neteller = function Neteller(_ref2) {
  var account = _ref2.account,
      intl = _ref2.intl,
      method = _ref2.method,
      change = _ref2.change,
      values = _ref2.values;

  return React.createElement(
    'div',
    null,
    React.createElement(Input, {
      disabled: account.accountId,
      value: values['account'],
      onChange: function onChange(e, account) {
        return change('account', account);
      },
      name: 'account',
      label: translate({ id: 'cashier.details.account' }, intl),
      required: true
    }),
    method === 'deposit' && React.createElement(Input, {
      name: 'secureId',
      value: values['secureId'],
      onChange: function onChange(e, secureId) {
        return change('secureId', secureId);
      },
      label: translate({ id: 'cashier.details.secureId' }, intl),
      type: 'number',
      required: true
    })
  );
};

var VenusPoint = function VenusPoint(_ref3) {
  var _React$createElement;

  var account = _ref3.account,
      intl = _ref3.intl,
      change = _ref3.change,
      values = _ref3.values;

  return React.createElement(
    'div',
    null,
    React.createElement(Input, (_React$createElement = {
      disabled: account.accountId,
      name: 'username',
      value: values['username'],
      onChange: function onChange(e, username) {
        return change('username', username);
      }
    }, _defineProperty(_React$createElement, 'value', account.maskedAccount), _defineProperty(_React$createElement, 'label', translate({ id: 'cashier.details.username' }, intl)), _React$createElement)),
    React.createElement(Input, {
      type: 'password',
      name: 'password',
      onChange: function onChange(e, password) {
        return change('password', password);
      },
      label: translate({ id: 'cashier.details.password' }, intl)
    })
  );
};

var Vega = function Vega(_ref4) {
  var account = _ref4.account,
      intl = _ref4.intl,
      change = _ref4.change;

  return React.createElement(
    'div',
    null,
    React.createElement(Input, {
      disabled: account.accountId,
      name: 'username',
      onChange: function onChange(e, username) {
        return change('username', username);
      },
      value: account.maskedAccount,
      label: translate({ id: 'cashier.details.username' }, intl)
    }),
    React.createElement(Input, {
      type: 'password',
      name: 'password',
      onChange: function onChange(e, password) {
        return change('password', password);
      },
      label: translate({ id: 'cashier.details.password' }, intl)
    })
  );
};

var PPro = function PPro() {
  return React.createElement(
    'div',
    null,
    React.createElement(Input, { type: 'hidden', name: 'service', value: 'GIROPAY' })
  );
};

var PhoneNumber = function PhoneNumber(_ref5) {
  var account = _ref5.account,
      intl = _ref5.intl,
      change = _ref5.change,
      values = _ref5.values;

  return React.createElement(
    'div',
    null,
    React.createElement(Input, {
      disabled: account.accountId,
      name: 'phoneNumber',
      value: values['phoneNumber'],
      onChange: function onChange(e, phoneNumber) {
        return change('phoneNumber', phoneNumber);
      },
      label: translate({ id: 'cashier.details.phoneNumber' }, intl),
      required: true
    })
  );
};

var Email = function Email(_ref6) {
  var account = _ref6.account,
      intl = _ref6.intl,
      change = _ref6.change,
      values = _ref6.values;

  return React.createElement(
    'div',
    null,
    React.createElement(Input, {
      disabled: account.accountId,
      name: 'email',
      value: values['email'],
      onChange: function onChange(e, email) {
        return change('email', email);
      },
      label: translate({ id: 'cashier.details.email' }, intl),
      required: true
    })
  );
};

var Banklocal = function Banklocal(_ref7) {
  var account = _ref7.account,
      intl = _ref7.intl,
      change = _ref7.change;

  return React.createElement(
    'div',
    null,
    React.createElement(Input, {
      value: account.accountId ? account.maskedAccount.replace(/-\d*/g, '') : undefined,
      onChange: function onChange(e, clearingNumber) {
        return change('clearingNumber', clearingNumber);
      },
      name: 'clearingNumber',
      label: translate({ id: 'cashier.details.clearingNumber' }, intl),
      disabled: account.accountId
    }),
    React.createElement(Input, {
      value: account.accountId ? account.maskedAccount.replace(/\d*-/g, '') : undefined,
      onChange: function onChange(e, accountNumber) {
        return change('accountNumber', accountNumber);
      },
      name: 'accountNumber',
      label: translate({ id: 'cashier.details.iban' }, intl),
      disabled: account.accountId
    })
  );
};

var BankIBAN = function BankIBAN(_ref8) {
  var account = _ref8.account,
      intl = _ref8.intl,
      change = _ref8.change,
      values = _ref8.values;

  return React.createElement(
    'div',
    null,
    React.createElement(Input, {
      required: true,
      value: account.accountId ? account.maskedAccount.replace(/^\S* /g, '') : undefined,
      onChange: function onChange(e, iban) {
        return change('iban', iban);
      },
      name: 'iban',
      label: translate({ id: 'cashier.details.iban' }, intl),
      disabled: account.accountId
    }),
    React.createElement(Input, {
      required: true,
      value: account.accountId ? account.maskedAccount.replace(/\s(.*)/g, '') : undefined,
      onChange: function onChange(e, bic) {
        return change('bic', bic);
      },
      name: 'bic',
      label: translate({ id: 'cashier.details.bic' }, intl),
      disabled: account.accountId
    }),
    React.createElement(Input, {
      required: true,
      value: values['beneficiaryName'],
      onChange: function onChange(e, beneficiaryName) {
        return change('beneficiaryName', beneficiaryName);
      },
      name: 'beneficiaryName',
      label: translate({ id: 'cashier.details.beneficiaryName' }, intl)
    }),
    React.createElement(Input, {
      required: true,
      value: values['bankName'],
      onChange: function onChange(e, bankName) {
        return change('bankName', bankName);
      },
      name: 'bankName',
      label: translate({ id: 'cashier.details.bankName' }, intl)
    })
  );
};

var AstroPayBank = function AstroPayBank(_ref9) {
  var account = _ref9.account,
      intl = _ref9.intl,
      country = _ref9.country,
      method = _ref9.method,
      detail = _ref9.detail,
      change = _ref9.change,
      values = _ref9.values,
      config = _ref9.config;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      banks = _useState2[0],
      setBanks = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  useEffect(function () {
    setIsLoading(true);

    axios.post(config.devcode.host + '/directa24/getBanksByCountry', {
      merchantId: config.MERCHANT_ID,
      countryCode: country
    }).then(function (res) {
      var banks = res.data.map(function (bank) {
        return bank.code;
      });
      setBanks(banks);
    }).finally(function () {
      return setIsLoading(false);
    });
  }, []);

  var translateMap = function translateMap(category) {
    return function (value) {
      return {
        value: value,
        label: astroPayBankTransaltions(intl, category, value)
      };
    };
  };

  var countryKey = country.toUpperCase();
  var methodDetails = {
    banks: banks.length > 0 ? banks : getByPath(detail, 'config[' + countryKey + '].banks'),
    idTypes: getByPath(detail, 'config[' + countryKey + '].idTypes'),
    accountTypes: getByPath(detail, 'config[' + countryKey + '].accountTypes'),
    services: getByPath(detail, 'config[' + countryKey + '].services')
  };

  if (isLoading) return React.createElement(Loader, { inline: true });

  return React.createElement(
    'div',
    null,
    method === 'withdraw' && methodDetails.idTypes && methodDetails.idTypes.length > 1 && React.createElement(
      Select,
      {
        required: true,
        name: 'nationalIdType',
        value: values['nationalIdType'],
        onChange: function onChange(e, nationalIdType) {
          return change('nationalIdType', nationalIdType);
        },
        label: translate({
          id: 'cashier.details.idType',
          defaultMessage: 'nationalIdType'
        }, intl) },
      !values['nationalIdType'] && React.createElement(
        Select.Option,
        { value: '', selected: true, disabled: true },
        translate({
          id: 'cashier.details.idType',
          defaultMessage: 'nationalIdType'
        }, intl)
      ),
      methodDetails.idTypes.map(translateMap('idTypes')).map(function (s) {
        return React.createElement(
          Select.Option,
          { value: s.value },
          s.label
        );
      })
    ),
    React.createElement(Input, {
      required: true,
      name: 'nationalId',
      value: values['nationalId'],
      onChange: function onChange(e, nationalId) {
        return change('nationalId', nationalId);
      },
      label: translate({
        id: 'cashier.details.nationalId',
        defaultMessage: 'nationalId'
      }, intl)
    }),
    method === 'withdraw' && methodDetails.banks && methodDetails.banks.length > 1 && React.createElement(
      Select,
      {
        required: true,
        name: 'bankCode',
        value: values['bankCode'],
        onChange: function onChange(e, bankCode) {
          return change('bankCode', bankCode);
        },
        label: translate({
          id: 'cashier.details.bankCode',
          defaultMessage: 'bankCode'
        }, intl) },
      !values['bankCode'] && React.createElement(
        Select.Option,
        { value: '', selected: true, disabled: true },
        translate({
          id: 'cashier.details.bankCode',
          defaultMessage: 'bankCode'
        }, intl)
      ),
      methodDetails.banks.map(translateMap('banks' + country)).map(function (s) {
        return React.createElement(
          Select.Option,
          { value: s.value },
          s.label
        );
      })
    ),
    method === 'withdraw' && ['BR', 'UY', 'IN'].includes(country) && React.createElement(Input, {
      required: true,
      name: 'bankBranch',
      value: values['bankBranch'],
      onChange: function onChange(e, bankBranch) {
        return change('bankBranch', bankBranch);
      },
      label: translate({
        id: 'cashier.details.bankBranch',
        defaultMessage: 'bankBranch'
      }, intl)
    }),
    method === 'withdraw' && methodDetails.accountTypes && methodDetails.accountTypes.length > 1 && React.createElement(
      Select,
      {
        required: true,
        name: 'accountType',
        value: values['accountType'],
        onChange: function onChange(e, accountType) {
          return change('accountType', accountType);
        },
        label: translate({
          id: 'cashier.details.accountType',
          defaultMessage: 'account type'
        }, intl) },
      !values['accountType'] && React.createElement(
        Select.Option,
        { value: '', selected: true, disabled: true },
        translate({
          id: 'cashier.details.accountType',
          defaultMessage: 'account type'
        }, intl)
      ),
      methodDetails.accountTypes.map(translateMap('accountTypes')).map(function (s) {
        return React.createElement(
          Select.Option,
          { value: s.value },
          s.label
        );
      })
    ),
    method === 'withdraw' && React.createElement(Input, {
      required: true,
      name: 'bankAccount',
      value: values['bankAccount'],
      onChange: function onChange(e, bankAccount) {
        return change('bankAccount', bankAccount);
      },
      label: translate({
        id: 'cashier.details.bankAccount',
        defaultMessage: 'bankAccount'
      }, intl)
    }),
    method === 'deposit' && methodDetails.services && methodDetails.services.length > 1 && React.createElement(
      Select,
      {
        required: true,
        name: 'service',
        value: values['service'],
        onChange: function onChange(e, service) {
          return change('service', service);
        },
        label: translate({
          id: 'cashier.details.service',
          defaultMessage: 'service'
        }, intl) },
      !values['service'] && React.createElement(
        Select.Option,
        { value: '', selected: true, disabled: true },
        translate({
          id: 'cashier.details.service',
          defaultMessage: 'service'
        }, intl)
      ),
      methodDetails.services.map(translateMap('services')).map(function (s) {
        return React.createElement(
          Select.Option,
          { value: s.value },
          s.label
        );
      })
    )
  );
};

var BankIntl = function BankIntl(_ref10) {
  var account = _ref10.account,
      intl = _ref10.intl,
      values = _ref10.values,
      change = _ref10.change,
      country = _ref10.country;

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    React.createElement(Input, {
      required: true,
      name: 'accountNumber',
      value: account.accountId ? account.maskedAccount.replace(/\d*-/g, '') : values['accountNumber'],
      onChange: function onChange(e, accountNumber) {
        return change('accountNumber', accountNumber);
      },
      label: translate({ id: 'cashier.details.iban' }, intl),
      disabled: account.accountId
    }),
    React.createElement(Input, {
      required: true,
      name: 'bic',
      value: account.accountId ? account.maskedAccount.replace(/\s(.*)/g, '') : values['bic'],
      onChange: function onChange(e, bic) {
        return change('bic', bic);
      },
      label: translate({ id: 'cashier.details.bic' }, intl),
      disabled: account.accountId
    }),
    ['AE'].includes(country) && React.createElement(
      React.Fragment,
      null,
      React.createElement(Input, {
        required: true,
        name: 'beneficiaryCountry',
        value: account.accountId ? account.maskedAccount.replace(/\s(.*)/g, '') : values['beneficiaryCountry'],
        onChange: function onChange(e, beneficiaryCountry) {
          return change('beneficiaryCountry', beneficiaryCountry);
        },
        label: translate({ id: 'cashier.details.beneficiaryCountry' }, intl),
        disabled: account.accountId
      }),
      React.createElement(Input, {
        required: true,
        name: 'bankName',
        value: account.accountId ? account.maskedAccount.replace(/\s(.*)/g, '') : values['bankName'],
        onChange: function onChange(e, bankName) {
          return change('bankName', bankName);
        },
        label: translate({ id: 'cashier.details.bankName' }, intl),
        disabled: account.accountId
      })
    )
  );
};

var CryptoCurrency = function CryptoCurrency(_ref11) {
  var intl = _ref11.intl,
      detail = _ref11.detail,
      method = _ref11.method,
      values = _ref11.values,
      change = _ref11.change;

  var methodDetails = {
    cryptoCurrencies: getByPath(detail, 'config.cryptoCurrencies', [])
  };

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    methodDetails.cryptoCurrencies.length > 0 && React.createElement(
      Select,
      {
        required: true,
        name: 'cryptoCurrency',
        value: values['cryptoCurrency'],
        onChange: function onChange(e, cryptoCurrency) {
          return change('cryptoCurrency', cryptoCurrency);
        },
        label: translate({
          id: 'cashier.details.cryptoCurrency',
          defaultMessage: 'Crypto currency'
        }, intl) },
      !values['cryptoCurrency'] && React.createElement(
        Select.Option,
        { value: '', selected: true, disabled: true },
        translate({
          id: 'cashier.details.select-cryptoCurrency',
          defaultMessage: 'Select crypto currency'
        }, intl)
      ),
      methodDetails.cryptoCurrencies.map(function (cryptoCurrency) {
        return React.createElement(
          Select.Option,
          { value: cryptoCurrency },
          cryptoCurrency
        );
      })
    ),
    method === 'withdraw' && React.createElement(Input, {
      required: true,
      name: 'walletAddress',
      value: values['walletAddress'],
      onChange: function onChange(e, walletAddress) {
        return change('walletAddress', walletAddress);
      },
      label: translate({
        id: 'cashier.details.walletAddress',
        defaultMessage: 'Wallet address'
      }, intl)
    })
  );
};

var Jeton = function Jeton(_ref12) {
  var account = _ref12.account,
      intl = _ref12.intl,
      values = _ref12.values,
      change = _ref12.change;

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    React.createElement(Input, {
      required: true,
      name: 'customerNumber',
      value: account.maskedAccount || values['customerNumber'],
      onChange: function onChange(e, customerNumber) {
        return change('customerNumber', customerNumber);
      },
      label: translate({ id: 'cashier.details.customerNumber' }, intl),
      disabled: account.accountId
    })
  );
};

var BestPay = function BestPay(_ref13) {
  var account = _ref13.account,
      intl = _ref13.intl,
      values = _ref13.values,
      change = _ref13.change;

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    React.createElement(Input, {
      required: true,
      name: 'accountNumber',
      value: account.accountId ? account.maskedAccount.replace(/\d*-/g, '') : values['accountNumber'],
      onChange: function onChange(e, accountNumber) {
        return change('accountNumber', accountNumber);
      },
      label: translate({ id: 'cashier.details.accountNumber' }, intl),
      disabled: account.accountId
    }),
    React.createElement(Input, {
      required: true,
      name: 'swiftCode',
      value: values['swiftCode'],
      onChange: function onChange(e, swiftCode) {
        return change('swiftCode', swiftCode);
      },
      label: translate({ id: 'cashier.details.swiftCode' }, intl)
    })
  );
};

var Mifinity = function Mifinity(_ref14) {
  var account = _ref14.account,
      intl = _ref14.intl,
      change = _ref14.change,
      values = _ref14.values;

  return React.createElement(
    'div',
    null,
    React.createElement(Input, {
      disabled: account.accountId,
      value: values['destinationAccount'],
      onChange: function onChange(e, account) {
        return change('destinationAccount', account);
      },
      name: 'destinationAccount',
      label: translate({ id: 'cashier.details.account' }, intl),
      required: true
    })
  );
};

var EzeeWallet = function EzeeWallet(_ref15) {
  var account = _ref15.account,
      intl = _ref15.intl,
      method = _ref15.method,
      change = _ref15.change;

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    React.createElement(Input, {
      required: true,
      name: 'walletId',
      label: translate({
        id: 'cashier.details.walletId',
        defaultMessage: 'Wallet ID'
      }, intl),
      disabled: account.accountId,
      onChange: function onChange(_, walletId) {
        return change('walletId', walletId);
      },
      value: account.maskedAccount
    }),
    method === 'deposit' && React.createElement(Input, {
      required: true,
      type: 'password',
      name: 'walletPassword',
      onChange: function onChange(_, walletPassword) {
        return change('walletPassword', walletPassword);
      },
      label: translate({
        id: 'cashier.details.walletPassword',
        defaultMessage: 'Wallet password'
      }, intl)
    })
  );
};

var Paramount = function Paramount(_ref16) {
  var account = _ref16.account,
      intl = _ref16.intl,
      values = _ref16.values,
      change = _ref16.change,
      detail = _ref16.detail;

  var methodDetails = {
    securityQuestions: getByPath(detail, 'config.securityQuestions', [])
  };

  return React.createElement(
    'div',
    { className: 'payment-account-info' },
    methodDetails.securityQuestions.length > 0 && React.createElement(
      Select,
      {
        required: true,
        disabled: account.accountId,
        name: 'securityQuestion',
        value: values['securityQuestion'],
        onChange: function onChange(_, securityQuestion) {
          return change('securityQuestion', securityQuestion);
        },
        label: translate({
          id: 'cashier.details.securityQuestion',
          defaultMessage: 'Security question'
        }, intl) },
      !values['securityQuestion'] && React.createElement(
        Select.Option,
        { value: '', selected: true, disabled: true },
        translate({
          id: 'cashier.details.select-securityQuestion',
          defaultMessage: 'Select security question'
        }, intl)
      ),
      methodDetails.securityQuestions.map(function (securityQuestion) {
        return React.createElement(
          Select.Option,
          { value: securityQuestion.value },
          translate({
            id: securityQuestion.id,
            defaultMessage: securityQuestion.value
          }, intl)
        );
      })
    ),
    React.createElement(Input, {
      required: true,
      type: 'password',
      name: 'securityAnswer',
      value: values['securityAnswer'],
      onChange: function onChange(_, securityAnswer) {
        return change('securityAnswer', securityAnswer);
      },
      label: translate({
        id: 'cashier.details.securityAnswer',
        defaultMessage: 'Security answer'
      }, intl)
    })
  );
};

export var SkrillDeposit = {
  component: injectIntl(Email),
  parser: Parser.parseEmail
};

export var CreditcardDeposit = {
  component: injectMethod({ method: 'deposit' }, injectIntl(Creditcard)),
  parser: Parser.parseCreditcard
};

export var NetellerDeposit = {
  component: injectMethod({ method: 'deposit' }, injectIntl(Neteller)),
  parser: Parser.parseNeteller
};

export var VenusPointDeposit = {
  component: injectMethod('deposit', injectIntl(VenusPoint)),
  parser: Parser.parseVenusPoint
};

export var VegaDeposit = {
  component: injectMethod('deposit', injectIntl(Vega)),
  parser: Parser.parseVega
};

export var SiruDeposit = {
  component: injectIntl(PhoneNumber),
  parser: Parser.parsePhoneNumber
};

export var MuchBetterDeposit = {
  component: injectIntl(PhoneNumber),
  parser: Parser.parsePhoneNumber
};

export var PProDeposit = {
  component: injectIntl(PPro),
  parser: identity
};

export var MobilePayDeposit = {
  component: injectIntl(PhoneNumber),
  parser: Parser.parsePhoneNumber
};

export var AstroPayBankDeposit = {
  component: injectMethod({ method: 'deposit' }, injectIntl(AstroPayBank)),
  initialValues: function initialValues(props) {
    var values = {};
    var details = {
      banks: getByPath(props.detail, 'config[' + props.country + '].banks', []),
      idTypes: getByPath(props.detail, 'config[' + props.country + '].idTypes', []),
      accountTypes: getByPath(props.detail, 'config[' + props.country + '].accountTypes', []),
      services: getByPath(props.detail, 'config[' + props.country + '].services', [])
    };

    if (details.services.length === 1) values.service = details.services[0];

    return values;
  },
  parser: identity
};

export var CryptoCurrencyDeposit = {
  component: injectMethod({ method: 'deposit' }, injectIntl(CryptoCurrency)),
  parser: identity
};

export var EzeeWalletDeposit = {
  component: injectMethod({ method: 'deposit' }, injectIntl(EzeeWallet)),
  parser: identity
};

export var ZimplerDeposit = null;
export var BankDeposit = null;
export var TrustlyDeposit = null;
export var EcoPayzDeposit = null;
export var EProPaymentWallDeposit = null;
export var IdealDeposit = null;
export var IDebitDeposit = null;
export var InstadebitDeposit = null;
export var PaysafecardDeposit = null;
export var FunangaDeposit = null;
export var BestPayDeposit = null;
export var BankIntlDeposit = null;
export var MiFinityEWalletDeposit = null;

export var BankIntlWithdrawal = {
  component: injectIntl(BankIntl),
  parser: identity
};

export var BestPayWithdrawal = {
  component: injectIntl(BestPay),
  parser: identity
};

export var CryptoCurrencyWithdrawal = {
  component: injectMethod({ method: 'withdraw' }, injectIntl(CryptoCurrency)),
  parser: identity
};

export var JetonWithdrawal = {
  component: injectIntl(Jeton),
  parser: identity
};

export var BankLocalWithdrawal = {
  component: injectIntl(Banklocal),
  parser: identity
};

export var BankIBANWithdrawal = {
  component: injectMethod({ method: 'withdraw' }, injectIntl(BankIBAN)),
  parser: identity
};

export var SkrillWithdrawal = {
  component: injectIntl(Email),
  parser: Parser.parseEmail
};

export var CreditcardWithdrawal = {
  component: injectMethod({ method: 'withdraw' }, injectIntl(Creditcard)),
  parser: Parser.parseCreditcard
};

export var VenusPointWithdrawal = {
  component: injectMethod('withdraw', injectIntl(VenusPoint)),
  parser: Parser.parseVenusPoint
};

export var VegaWithdrawal = {
  component: injectMethod('withdraw', injectIntl(Vega)),
  parser: Parser.parseVega
};

export var NetellerWithdrawal = {
  component: injectMethod({ method: 'withdraw' }, injectIntl(Neteller)),
  parser: Parser.parseNeteller
};

export var MuchBetterWithdrawal = {
  component: injectIntl(PhoneNumber),
  parser: Parser.parsePhoneNumber
};

export var AstroPayBankWithdrawal = {
  component: injectMethod({ method: 'withdraw' }, injectIntl(AstroPayBank)),
  initialValues: function initialValues(props) {
    var values = {};
    var details = {
      banks: getByPath(props.detail, 'config[' + props.country + '].banks', []),
      idTypes: getByPath(props.detail, 'config[' + props.country + '].idTypes', []),
      accountTypes: getByPath(props.detail, 'config[' + props.country + '].accountTypes', []),
      services: getByPath(props.detail, 'config[' + props.country + '].services', [])
    };

    if (details.idTypes.length === 1) values.nationalIdType = details.idTypes[0];
    if (details.banks.length === 1) values.bankCode = details.banks[0];
    if (details.accountTypes.length === 1) values.accountType = details.accountTypes[0];
    return values;
  },
  parser: identity
};

export var EzeeWalletWithdrawal = {
  component: injectMethod({ method: 'withdraw' }, injectIntl(EzeeWallet)),
  parser: identity
};

export var ParamountWithdrawal = {
  component: injectIntl(Paramount),
  parser: Parser.parseParamount
};

export var MiFinityEWalletWithdrawal = {
  component: injectIntl(Mifinity),
  parser: identity
};

export var ZimplerWithdrawal = null;
export var BankWithdrawal = null;
export var TrustlyWithdrawal = null;
export var EcoPayzWithdrawal = null;
export var EProPaymentWallWithdrawal = null;
export var IdealWithdrawal = null;
export var IDebitWithdrawal = null;
export var InstadebitWithdrawal = null;
export var PaysafecardWithdrawal = null;
export var InteracWithdrawal = null;